import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";

import "@/plugins/onlyNumber.js";
import "@/plugins/mixins.js";

import Utils from "@/common/utils";
import Ajax from "@/plugins/ajax.js";
Vue.prototype.$utils = Utils;
Vue.prototype.$ajax = Ajax;

import bus from "@/plugins/bus";
Vue.use(bus);
// 动态导入三方库
import ElementUI from "element-ui";
Vue.use(ElementUI);

import { t, i18nScope } from "./languages";
Vue.prototype.$t = t;

import("@voerkai18n/vue2").then(({ i18nPlugin }) => {
  Vue.use(i18nPlugin, { i18nScope });
});

Vue.config.productionTip = false;
new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#root");
